import axios from "axios";

let _initialized = false;
let _pending = 0;

const _show = () => {
  const el = document.getElementById("rn-progress-bar");
  if (!el) return;
  el.style.width = "80%";
  el.style.opacity = "1";
};

const _done = () => {
  const el = document.getElementById("rn-progress-bar");
  if (!el) return;
  el.style.width = "100%";
  setTimeout(() => {
    el.style.transition = "none";
    el.style.width = "0%";
    el.style.opacity = "0";
    setTimeout(() => {
      el.style.transition = "";
    }, 50);
  }, 300);
};

/**
 * Registers Axios request/response interceptors that drive the
 * #rn-progress-bar element. Safe to call multiple times (no-op after first).
 */
export const setupAxiosProgress = () => {
  if (_initialized) return;
  _initialized = true;

  axios.interceptors.request.use((config) => {
    _pending++;
    if (_pending === 1) _show();
    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      _pending = Math.max(0, _pending - 1);
      if (_pending === 0) _done();
      return response;
    },
    (error) => {
      _pending = Math.max(0, _pending - 1);
      if (_pending === 0) _done();
      return Promise.reject(error);
    }
  );
};
